import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mj-welcome',
  templateUrl: './welcome.template.html',
  styleUrls: ['./welcome.style.scss'],
})
export class WelcomeComponent {
  @Output() hide: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() hideOnce: EventEmitter<boolean> = new EventEmitter<boolean>();

  public content: any;
  public step = 0;
  public numSteps = 4;

  public isAnimating: boolean = false;

  constructor(private _router: Router, private _translate: TranslateService) {
    this.content = {};

    // Retrieves steps from current language's strings
    for (let i = 0; i <= this.numSteps; i++) {
      this._translate
        .get([
          'dashboard_tour_step_' + i + '_title',
          'dashboard_tour_step_' + i + '_desc',
          'dashboard_tour_step_' + i + '_hint',
        ])
        .subscribe(stepStrings => {
          const stepContent = {
            title: stepStrings['dashboard_tour_step_' + i + '_title'],
            desc: stepStrings['dashboard_tour_step_' + i + '_desc'],
            hint: stepStrings['dashboard_tour_step_' + i + '_hint'],
          };
          this.content[i] = stepContent;
        });
    }
  }

  public navigate() {
    this._router.navigate(['overview', 'post']);
  }

  public checkStep(num: number): boolean {
    return this.step === num;
  }

  public next() {
    if (this.step < this.numSteps) {
      this.isAnimating = true;

      setTimeout(() => {
        this.step++;
        this.isAnimating = false;
      }, 250);
    }
  }

  public hideClicked() {
    this.hide.emit(true);
  }

  public hideWelcomeOnce() {
    this.hideOnce.emit(true);
  }
}
